<template>
  <div>
    <v-card>
      <v-card-title class="headline">Заявка на пропуск
      </v-card-title>

      <v-card-text v-if="editable.can_see">
        <v-row>
          <v-col cols="9">
            <v-card class="pa-4">
              <div>
                <v-row>
                  <v-col>
                    <v-row>
                      <p
                        class="subtitle-2 text-left"
                      >
                          <v-chip :color="status_descr(GETTERS_PASS_ALL.status, 'color')" text-color="white">
                            <v-avatar left>
                              <v-icon color="white">mdi-calendar-month</v-icon>
                            </v-avatar>
                                <b style="color:white;">{{format_dateinterval(GETTERS_PASS_ALL)}}</b>
                          </v-chip>
                      </p>
                    </v-row>
                    <v-row v-if="GETTERS_PASS_ALL.type == 2" style="margin-top: -16px !important;">
                      <p class="mb-0 ml-2">до 18:00 (без сопровождения)</p>
                    </v-row>
                    <v-row v-if="GETTERS_PASS_ALL.type == 1" style="margin-top: -16px !important;">
                      <p class="mb-0 ml-2">до 23:00 (с сопровождением)</p>
                    </v-row>
                  </v-col>
                  <v-col v-if="GETTERS_PASS_ALL.need_applicant_equipment_pass">
                    <p
                      class="subtitle-2 text-left"
                    >
                        <v-chip color="#ff0000" text-color="white">
                              <b style="color:white;">требуется мат.пропуск</b>
                        </v-chip>
                    </p>
                  </v-col>
                  <v-col>
                    <p
                      class="subtitle-2 text-left"
                    >
                        <v-chip :color="status_descr(GETTERS_PASS_ALL.status, 'color')" text-color="white">
                              <b style="color:white;">{{status_descr(GETTERS_PASS_ALL.status, 'descr')}}</b>
                        </v-chip>
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p class="subtitle-2 text-left">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-google-circles</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >{{GETTERS_PASS_ALL.proposal.station}} ({{ place_descr(GETTERS_PASS_ALL.place) }})</b>
                        </v-chip>
                    </p>
                  </v-col>
                  <v-col>
                    <p class="subtitle-2 text-left">
                        <v-chip color="#c22dff" text-color="white">
                        <!-- <v-chip color="#c22dff" text-color="white" @click="show_proposal()"> -->
                          <v-avatar left>
                            <v-icon color="white">mdi-alpha-p-box</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >#{{GETTERS_PASS_ALL.proposal.id}}</b>
                        </v-chip>
                    </p>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row>
                  <v-col cols="3">
                    <v-card-text>
                      <p> Инициатор: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9">
                    <p class="subtitle-2 text-left">
                      <v-badge color="red lighten-2" :content="GETTERS_PASS_ALL.creator.individual.phone_number" x-small overlap>
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-account</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >{{ GETTERS_PASS_ALL.creator.individual.last_name }} {{ GETTERS_PASS_ALL.creator.individual.first_name }} {{ GETTERS_PASS_ALL.creator.individual.middle_name }}</b>
                        </v-chip>
                      </v-badge>
                    </p>

                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row style="padding-right: 80px;">
                  <v-col cols="3">
                    <v-card-text>
                      <p> Гости: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9">
                    <v-card-text v-for="guest in GETTERS_PASS_ALL.guest" :key="guest.id" style="text-align: left; font-size: 14px; padding: 0px; padding-left: 15px;">
                      <p><b> {{ guest.individual.last_name }} {{ guest.individual.first_name }} {{ guest.individual.middle_name }}</b> , {{ guest.individual.phone_number }}
                        <br>   - {{ guest.individual.organization }}</p>
                    </v-card-text>

                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row style="padding-right: 80px;">
                  <v-col cols="3">
                    <v-card-text>
                      <p> Ответственный: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9">
                    <div v-for="resp in GETTERS_PASS_ALL.responsible" :key="resp.id" >
                      <v-row>
                        <p class="subtitle-2 text-left">
                          <v-badge color="red lighten-2" :content="resp.individual.phone_number" x-small overlap>
                            <v-chip :color="$mainColor" text-color="white">
                              <v-avatar left>
                                <v-icon color="white">mdi-account</v-icon>
                              </v-avatar>
                              <b style="color:white;">
                                {{ resp.individual.last_name }} {{ resp.individual.first_name }} {{ resp.individual.middle_name }}
                              </b>
                            </v-chip>
                          </v-badge>
                        </p>

                      </v-row>

                    </div>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row style="padding-right: 80px;">
                  <v-col cols="3">
                    <v-card-text>
                      <p> Обоснование, доп.информация: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9">
                    <p v-if="GETTERS_PASS_ALL.reason"> {{ GETTERS_PASS_ALL.reason }}</p>
                    <p v-else> - не указано</p>
                  </v-col>
                </v-row>
              </div>
            </v-card>

          </v-col>
          <v-col cols="3">
            <v-card class="pa-2">
              <v-row v-if="GETTERS_PASS_ALL.status == 3 && GETTERS_PASS_ALL.admin_text">
                <p
                    class="subtitle-2 text-left pl-2"
                  >
                    {{ GETTERS_PASS_ALL.admin_text }}
                </p>
              </v-row>

              <template v-if="editable.can_print_pdf">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_pass(5)"
                      outlined
                      width="100%"
                    >proposal в .PDF</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>

              <template v-if="editable.can_export">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_pass(1)"
                      outlined
                      width="100%"
                    >Форма 2</v-btn>
                    </div>
                  </template>
                </v-list-item>
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_pass(2)"
                      outlined
                      width="100%"
                    >Форма 4</v-btn>
                    </div>
                  </template>
                </v-list-item>
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_pass(3)"
                      outlined
                      width="100%"
                    >СЗ Форма 2</v-btn>
                    </div>
                  </template>
                </v-list-item>
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_pass(4)"
                      outlined
                      width="100%"
                    >СЗ Форма 4</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>


              <v-divider class="mt-4"></v-divider>

              <template>
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 99, pass_status_change_dialog = true"
                      outlined
                      width="100%"
                    >DEBUG_BUTTON</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>

              <v-divider class="mt-4"></v-divider>

              <template v-if="editable.buttons.in_work">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 1, pass_status_change_dialog = true"
                      outlined
                      width="100%"
                    >Взять в работу</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>
              <template v-if="editable.buttons.reject">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 3, pass_status_change_dialog = true"
                      outlined
                      width="100%"
                    >отклонить</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>
              <template  v-if="editable.buttons.done">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 2, pass_status_change_dialog = true"
                      outlined
                      width="100%"
                    >Оформлен</v-btn>
                    </div>
                    <v-spacer style="height:10px;"></v-spacer>
                  </template>
                </v-list-item>
              </template>

              <v-divider class="mt-4"></v-divider>

              <p class="mb-0 mt-2 ml-4">История действий:</p>
              <template v-for="hist in history">
                <v-card v-if="hist.is_active" class="ma-2 pt-2 pl-2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-card-title 
                        v-bind="attrs"
                        v-on="on"
                        class="pa-0"> {{  hist.action.descr }}</v-card-title>
                    </template>
                    <span>{{ hist.action.descr_full }}</span>
                  </v-tooltip>
                  <v-card-text class="pa-0"> {{  hist.creator.individual.first_name }} {{  hist.creator.individual.last_name }}</v-card-text>
                  <v-card-text class="pa-0"> {{  hist.created_at.substr(0,16) }}</v-card-text>
                  <v-card-text class="pa-0" v-if="hist.comment"> {{  hist.comment }}</v-card-text>
                </v-card>
              </template>

            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>

        <!-- диалог карточки заявки -->
    <!-- <v-dialog v-model="proposalDialogCard">
      <modal-card
        @closeProposalDialog="proposalDialogCard=false"
        :from_pass_card="true"
      />
    </v-dialog> -->


    <v-dialog v-model="pass_status_change_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Изменить статус пропуска
        </v-card-title>
        <v-card-text >Вы уверены?</v-card-text>

        <v-card-text>
          <v-textarea
            v-if="new_status==3"
            v-model="change_dialog_text"
            outlined
            placeholder="Причина отклонения"
            type="number"
            counter="300"
            maxLength="300"
            rows="2"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="pass_status_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="change_pass_status()">Подтвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import { DOMEN } from '../../../../vars.js'

export default {
  beforeMount (){
    console.log('passModalCard', this.GETTERS_PASS_ALL)
    this.load_available_actions()
  },

  mounted() {
  },

  name: 'passModalCard',

  props: {
    from_proposal: Boolean,
  },

  // components: {
  //   modalCard: () => import('../../Proposals/modalCard.vue'),
  // },

  data: () => ({
    new_status: 0,
    pass_status_change_dialog: false,
    change_dialog_text: '',

    editable: {
      can_see: false,
      can_edit : false,
      can_export : false,
      buttons : {
        reject : false,
        done : false,
        in_work : false,
      }
    },
    // proposalDialogCard: false,
    history: [],
  }),

  watch: {
    GETTERS_PASS_ALL(val) {
      this.load_available_actions()
    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_PASS_ALL',
      'GETTERS_INPUT_ALL',
    ]),
  },

  created() {
  },

  methods: {
    ...mapActions([
      'EXPORT_PASS_DOC',
      'NEXT_PASS_STATUS',
      'GET_PASS_AVAILABLE_ACTIONS',
      // 'GET_INPUT_ALL',
      'GET_ACTIONS_HISTORY',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      // 'UPDATE_BASE_PROPOSAL_ID',
    ]),

    // show_proposal(){
    //   if(!this.from_proposal){
    //     this.UPDATE_BASE_PROPOSAL_ID(this.GETTERS_PASS_ALL.proposal.id)
    //     this.UPDATE_OVERLAY(true)
    //     this.GET_INPUT_ALL(this.GETTERS_PASS_ALL.proposal.id)
    //       .then(() => {
    //         this.UPDATE_OVERLAY(false)
    //         // console.log('show_proposal', this.GETTERS_INPUT_ALL)
    //         this.proposalDialogCard = true
    //       })        
    //   }
      
    // },

    place_descr(place){
      if(place == 1)
        return 'территория, 348'
      else if(place == 2)
        return 'территория, 21Б'
      else
        return 'территория'
    },

    load_available_actions(){
      this.editable = {
          can_see: false,
          can_edit : false,
          can_export : false,
          buttons : {
            reject : false,
            done : false,
            in_work : false,
          }
        },

      this.GET_PASS_AVAILABLE_ACTIONS(this.GETTERS_PASS_ALL.id).then(res => {
        this.editable = res
        this.load_history()
      })
    },

    load_history(){
      var data = {
        object_type: 2,
        object_id: this.GETTERS_PASS_ALL.id
      }

      this.GET_ACTIONS_HISTORY(data).then(res => {
        this.history = res.history

      })
    },

    change_pass_status(){
      this.UPDATE_OVERLAY(true)

      // for debug
      if(this.new_status == 99){
        this.NEXT_PASS_STATUS({
          pass_id: this.GETTERS_PASS_ALL.id, 
          action: 'debug',
        })
        .then(res => {
          this.pass_status_change_dialog = false
          if(res.status){
            this.$messageHelper(`Статус пропуска успешно изменен`, 'success', 5000)
            this.$emit('updateParent', {item: -1, close_modal: false})
            this.UPDATE_OVERLAY(false)
          }
          else{
            this.UPDATE_OVERLAY(false)
            if(res.error !== undefined){
              this.$messageHelper(res.error, 'error', 5000)
            }
            else
              this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })
        return
      }


      this.NEXT_PASS_STATUS({
        pass_id: this.GETTERS_PASS_ALL.id, 
        action: 'next_status',
        new_status_id: this.new_status,
        reason: this.change_dialog_text,
      })
      .then(res => {
        this.pass_status_change_dialog = false
        if(res.status){
          this.$messageHelper(`Статус пропуска успешно изменен`, 'success', 5000)
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.UPDATE_OVERLAY(false)
        }
        else{
          this.UPDATE_OVERLAY(false)
          if(res.error !== undefined){
            this.$messageHelper(res.error, 'error', 5000)
          }
          else
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })

    },
    
      
    print_pass(type){
      // console.log('print_pass', type)
      this.UPDATE_OVERLAY(true)
      var data = {
        pass_id: this.GETTERS_PASS_ALL.id, 
        type: type,
        action: 'print'
      }
      this.EXPORT_PASS_DOC(data)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          if(res.urls != undefined){
            res.urls.forEach(url => {
              // console.log('EXPORT_PASS_DOC', `${DOMEN}${url}`)
              window.open(`${DOMEN}${url}`, '_blank');
            })
          }

          else if(res.url != undefined){
            // console.log('EXPORT_PASS_DOC', `${DOMEN}${res.url}`)
            window.open(`${DOMEN}${res.url}`, '_blank');
          }
          else
            this.$messageHelper('error', 'error', 3000);
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
          this.$messageHelper(res.data.error, 'error', 3000);
          console.log('print_pass_error', e)
        });
    },

    status_descr(status, type){
      if(type == 'descr'){
        if (status == 4)
          return 'Черновик'
        else if (status == 0)
          return 'Новый запрос'
        else if (status == 1)
          return 'Оформляется'
        else if (status == 2)
          return 'Готов'
        else if (status == 3)
          return 'Отменен'
        else if (status == 5)
          return 'Удален'
        else
          return 'Не определен'
      }
      else{
        if (status == 0 || status == 4)
          return '#a9a9a9'
        else if (status == 1)
          return '#ada509'
        else if (status == 2)
          return '#1b8e30'
        else if (status == 3)
          return 'red lighten-2'
        else if (status == 5)
          return '#794606'
        else
          return 'red lighten-2'
      }
    },

    format_dateinterval(item){
      var date_obj_1 = new Date(item.start_date)
      var date_obj_2 = new Date(item.finish_date)

      return this.formate_date(date_obj_1) + ' : ' + this.formate_date(date_obj_2)
    },
    formate_date(date_obj){
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear()
    },
  }

};
</script>
